import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TabConfigStructure} from "../../../config/tab-config-structure";
import {ConfigStructure} from "../../../config/config-structure.model";
import {Property} from "../../property/property.model";
import {HtmlUtilsService} from "../../../html-utils/html-utils.service";

@Component({
  selector: 'app-metadata-tabs',
  templateUrl: './metadata-tabs.component.html',
  styleUrls: ['./metadata-tabs.component.scss']
})
export class MetadataTabsComponent implements OnInit {

  @Input() tabs: TabConfigStructure[] = [];

  @Input() tabProperties: Property [] = [];

  @Input() object: any;

  @Output() activeTabId: EventEmitter<number> = new EventEmitter();

  private tabsSize: number;

  private defaultTab: number;

  isMobile: boolean = false;

  selectedTab: number;
  selectedTabObject: TabConfigStructure;

  selectedTabConfig: ConfigStructure[] = [];

  constructor(private htmlUtils: HtmlUtilsService) { }

  ngOnInit() {
    this.getDefaultTab(this.tabs);
    this.isMobile = this.htmlUtils.mobileVersion;
    this.htmlUtils.mobileBehaviorSubject.subscribe(value => {
      this.isMobile = value;
    })
  }

  private getDefaultTab(tabs: TabConfigStructure[]){
    if(tabs){
      this.tabsSize = tabs.length;
      this.defaultTab = tabs.indexOf(tabs.find( t => t.defaultTab === true));
      if(this.defaultTab === -1){
        this.defaultTab = 0;
      }
      this.selectedTab = this.defaultTab;
      this.getSelectedTabConfig(this.selectedTab);
      this.selectTab(this.selectedTab);
    }
  }

  private getSelectedTabConfig(index: number){
    this.selectedTabConfig = this.tabs[index].config;
  }

  selectTab(index: number){
    if(index >=0 && index< this.tabsSize){
      this.selectedTab = index;
    }
    else {
      this.selectedTab = this.defaultTab;
    }
    this.getSelectedTabConfig(index);
    this.selectedTabObject = this.tabs[this.selectedTab];
  }

}
